function seat(color) {
  if (!color) {
    const defaultColor = '#EAEAEA'
    return `
      <rect x="5" y="3" width="12" height="12" rx="2" fill="${defaultColor}"/>
      <path d="M2 3.41176C2 2.63207 2.39885 2 3.22727 2C4.0557 2 4.45455 2.63207 4.45455 3.41176V15.6H17.5455V3.41176C17.5455 2.63207 17.9443 2 18.7727 2C19.6012 2 20 2.63207 20 3.41176V16.5882C20 17.3679 19.3284 18 18.5 18H3.5C3.39645 18 3.29534 17.9901 3.1977 17.9713C2.51417 17.8397 2 17.2705 2 16.5882V3.41176Z" fill="${defaultColor}"/>
    `
  }
  return `
    <rect x="5" y="3" width="12" height="12" rx="2" fill="${color}"/>
    <path d="M2 3.41176C2 2.63207 2.39885 2 3.22727 2C4.0557 2 4.45455 2.63207 4.45455 3.41176V15.6H17.5455V3.41176C17.5455 2.63207 17.9443 2 18.7727 2C19.6012 2 20 2.63207 20 3.41176V16.5882C20 17.3679 19.3284 18 18.5 18H3.5C3.39645 18 3.29534 17.9901 3.1977 17.9713C2.51417 17.8397 2 17.2705 2 16.5882V3.41176Z" fill="${color}"/>
  `
}
const noSeat = ``

const NotAvailableSeat = `
<rect x="5" y="3" width="12" height="12" rx="2" fill="#FAFAFA"/>
<path d="M2 3.41176C2 2.63207 2.39885 2 3.22727 2C4.0557 2 4.45455 2.63207 4.45455 3.41176V15.6H17.5455V3.41176C17.5455 2.63207 17.9443 2 18.7727 2C19.6012 2 20 2.63207 20 3.41176V16.5882C20 17.3679 19.3284 18 18.5 18H3.5C3.39645 18 3.29534 17.9901 3.1977 17.9713C2.51417 17.8397 2 17.2705 2 16.5882V3.41176Z" fill="#CFCFCF"/>
`
const ameaSeat = `
<rect x="5" y="3" width="12" height="12" rx="2" fill="#77ACDB"/>
<path d="M2 3.41176C2 2.63207 2.39885 2 3.22727 2C4.0557 2 4.45455 2.63207 4.45455 3.41176V15.6H17.5455V3.41176C17.5455 2.63207 17.9443 2 18.7727 2C19.6012 2 20 2.63207 20 3.41176V16.5882C20 17.3679 19.3284 18 18.5 18H3.5C3.39645 18 3.29534 17.9901 3.1977 17.9713C2.51417 17.8397 2 17.2705 2 16.5882V3.41176Z" fill="#77ACDB"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.625 5.375C9.625 4.61561 10.2406 4 11 4C11.7594 4 12.375 4.61561 12.375 5.375C12.375 6.13439 11.7594 6.75 11 6.75C10.2406 6.75 9.625 6.13439 9.625 5.375ZM11 4.75C10.6548 4.75 10.375 5.02982 10.375 5.375C10.375 5.72018 10.6548 6 11 6C11.3452 6 11.625 5.72018 11.625 5.375C11.625 5.02982 11.3452 4.75 11 4.75Z" fill="#141414"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 7C10.1716 7 9.5 7.62203 9.5 8.38935V10.4207C9.5 11.188 10.1716 11.81 11 11.81H11.5L12.7057 11.8182C13.0565 11.8182 13.3886 11.9858 13.6091 12.2743L14.8118 13.8479C14.9461 14.0237 15.1898 14.0511 15.3561 13.9091C15.5224 13.7672 15.5484 13.5096 15.414 13.3339L14.2113 11.7602C13.8439 11.2794 13.2905 11 12.7057 11H12.5V8.38935C12.5 7.62203 11.8284 7 11 7ZM11.6818 11V8.38935C11.6818 8.04057 11.3766 7.75783 11 7.75783C10.6234 7.75783 10.3182 8.04057 10.3182 8.38935V10.3685C10.3182 10.7173 10.6234 11 11 11H11.6818Z" fill="#141414"/>
<path d="M7 11C7 9.78927 7.71724 8.74604 8.75 8.27203V9.1289C8.14701 9.53253 7.75 10.2199 7.75 11C7.75 12.2427 8.75736 13.25 10 13.25C10.6664 13.25 11.2651 12.9603 11.6771 12.5H12.5987C12.0799 13.3967 11.1104 14 10 14C8.34315 14 7 12.6569 7 11Z" fill="#141414"/>
`

const ameaCompanionSeat = `
  <rect x="5" y="3" width="12" height="12" rx="2" fill="#77ACDB"/>
  <path d="M2 3.41176C2 2.63207 2.39885 2 3.22727 2C4.0557 2 4.45455 2.63207 4.45455 3.41176V15.6H17.5455V3.41176C17.5455 2.63207 17.9443 2 18.7727 2C19.6012 2 20 2.63207 20 3.41176V16.5882C20 17.3679 19.3284 18 18.5 18H3.5C3.39645 18 3.29534 17.9901 3.1977 17.9713C2.51417 17.8397 2 17.2705 2 16.5882V3.41176Z" fill="#77ACDB"/>
`

export const plainSeat = () => {
  return seat
}

export const wheelchairSeat = () => {
  return ameaSeat
}

export const ameaCompanionSeatChoice = () => {
  return ameaCompanionSeat
}

export const getAllSeatTypes = (areas, notAvailableSeatIcon = null) => {
  let seatTypesArray = [
    {
      name: 'Amea',
      icon: '/assets/imgs/seats/amea.svg',
    },
    {
      name: 'AmeaCompanion',
      icon: '/assets/imgs/seats/amea-companion.svg',
    },
    {
      name: 'NotAvailable',
      icon: notAvailableSeatIcon || '/assets/imgs/seats/not-available.svg',
    },
  ]

  if (areas.size > 1) {
    const newAreasArray = []

    Array.from(areas).forEach((area) => {
      newAreasArray.push({
        dynamic: true,
        name: area[1].areaCategory,
        icon: seat(area[1].areaCategoryColor),
      })
    })

    seatTypesArray = newAreasArray.concat(seatTypesArray)
  } else {
    seatTypesArray.unshift({
      name: 'Available',
      icon: '/assets/imgs/seats/available.svg',
    })
  }

  return seatTypesArray
}

export const seatCodeTypes = (color) => {
  const seatCodeTypes = {
    '-2': { name: 'Corridor', icon: noSeat },
    '-1': { name: 'NotExist', icon: noSeat },
    0: { name: 'Empty', icon: seat() },
    1: { name: 'Sold', icon: NotAvailableSeat },
    // sold inside cinema NOT online
    2: { name: 'House', icon: NotAvailableSeat },
    3: { name: 'Special', icon: ameaSeat },
    4: { name: 'Reserved', icon: seat() },
    5: { name: 'Broken', icon: '' },
    6: { name: 'Placeholder', icon: '' },
    7: { name: 'Companion', icon: ameaCompanionSeat },
  }

  // seat color for empty seats only and if there are multiple areas
  if (color) {
    seatCodeTypes[0].icon = seat(color)
  }

  return seatCodeTypes
}
